
<template>
  <!--报名名单-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="memberId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <span>{{row.mobilePhone}}</span>
      </template>
      <template slot="opt_money" slot-scope="{row}">
        <span>{{row.totalFee | toMoney}}</span>
      </template>
      <template slot="opt_payFee" slot-scope="{row}">
        <span>{{row.payFee | toMoney}}</span>
      </template>

      <template slot="opt_h" slot-scope="{row}">
        <a-tooltip :title="row.applyGoods">
          <div class="feed-over-text" @click="showDetail(row.applyGoods)">{{row.applyGoods}}</div>
        </a-tooltip>
      </template>
    </x-tabula>

    <!--项目内容的弹窗-->
    <a-modal
      title="项目"
      :visible="projectVisible"
      @cancel="projectVisible=false"
      :footer="null"
      :maskClosable="true"
      :keyboard="true"
      destroyOnClose
      centered
      :width="900"
    >
      <div>{{projectContent}}</div>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import { empty } from 'ant-design-vue-admin-x';
export default {
  mixins: [fetchSelect],
  name: 'ActivityApplyList',
  data () {
    return {
      projectVisible: false,
      projectContent: '',
      visible: false,
      balance: '',
      currentRow: {},
      searchList: [
        { props: ['keyWords'], placeholder: '活动标题关键字', options: [], inputType: 'input' },
        { props: ['type'], placeholder: '活动类型', options: [{label: '活动', value: 1}, {label: '团购', value: 2}], inputType: 'select' },
        { props: ['applyStatus'], placeholder: '报名状态', options: [{label: '已报名', value: 1}, {label: '已拒绝', value: 2}, {label: '已取消', value: 3}], inputType: 'select' },
        { props: ['mobile'], placeholder: '报名账号', options: [], inputType: 'input' },
        { props: ['activityApplyId'], placeholder: '报名码', options: [], inputType: 'input' },
        { props: ['activityId'], placeholder: '活动ID', options: [], inputType: 'input' }
      ],
      searchParams: {
        keyWords: undefined,
        type: undefined,
        applyStatus: undefined,
        mobile: undefined,
        activityId: undefined,
        activityApplyId: undefined
      },
      tableOptList: [],
      rowOptList: [
        { text: '详情', handle: (row) => this.toDetail(row.activityApplyId), permi: ['community:activityApply:query'] }

      ],
      columns: [
        { title: '昵称', dataIndex: 'nickName', align: 'left', width: '' },
        { title: '账号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '活动标题', dataIndex: 'title', align: 'left', width: '' },
        { title: '类型', dataIndex: 'typeDesc', align: 'left', width: '' },
        { title: '项目', dataIndex: 'applyGoods', align: 'left', width: '', scopedSlots: {customRender: 'h'}},
        { title: '总金额', dataIndex: 'totalFee', align: 'left', width: '', scopedSlots: {customRender: 'money'}},
        { title: '实付', dataIndex: 'payFee', align: 'left', width: '', scopedSlots: {customRender: 'payFee'}},
        { title: '报名时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '状态', dataIndex: 'applyStatusDesc', align: 'left', width: '' },

        // { title: '手机号', dataIndex: 'mobilePhone', align: 'left', width: '', scopedSlots: {customRender: 't'} },

        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/activity/apply/listPage',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  created () {
    this.searchParams.activityId = this.$route.query.activityId;
    this.$nextTick(() => {
      if (this.searchParams.activityId) {
        this.$refs.table.$refs.search.changeFold();
        empty.$emit('setSearchValue', {
          activityId: this.searchParams.activityId
        });
      }
    });
  },
  mounted () {
    this.getSelect();
  },
  filters: {
    toMoney (val) {
      if (val != null) {
        return '￥' + Number(val).toFixed(2);
      } else {
        return '';
      }
    }
  },
  methods: {
    /* 查看项目内容 */
    showDetail (content) {
      this.projectContent = content;
      this.projectVisible = true;
    },
    /* 获取下拉 */
    getSelect () {
      this.communitySelect(0, 'searchList', 1);
      let paramArr = [
        {index: 3, scope: 'searchList', query: 'comu_member_register_type'},
        {index: 4, scope: 'searchList', query: 'comu_member_register_platform'}
      ];
      this.dictionarySelect(paramArr);
    },
    /* 查看报名名单详情 */
    toDetail (id) {
      this.$router.push({
        name: 'ActivityApplyDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>

<style lang="less" scoped>
.box{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-content: center;
  vertical-align: middle;
}
</style>
